import React from 'react';
import PropTypes from "prop-types";
import { MenuItem } from "@blueprintjs/core";
import { Select } from "@blueprintjs/select";
import WebNetButton from "./WebNetButton";

import i18n from '../i18n';
import { useTranslation } from 'react-i18next';



export default class LanguageSelect extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            languages: ["en", "fi", "es",],    //  "de", "fr"
            defaultLng: "en",
        }

        this.changeLanguage = this.changeLanguage.bind(this);
        this.getActiveItem = this.getActiveItem.bind(this);
    }

    componentDidMount() { 
        let lng = localStorage.getItem("i18nextLng");
        //console.log(lng);
        this.setState({ defaultLng: lng ? lng : "en" });
    }

    changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
        this.props.handleLanguageSelected(lng);
        
    };


    getActiveItem = () => {
        return this.props.languageSelected;
    }

    render() { 
        const { languages, defaultLng  } = this.state;

        return (          
            <Select id="selectID"
                items={languages}
                itemPredicate={(query, item) => {
                    return item.match(new RegExp(`${query}`, "i"));
                }}
                itemRenderer={(item) => <MenuItem onClick={() => { return this.changeLanguage(item) } } key={item} text={item} />}
                activeItem={this.getActiveItem()}
                filterable={false}
            >
                <WebNetButton neverActive={false} text={defaultLng} rightIcon="caret-down" path="/" icon=""  />
            </Select>
            
        );
    }
};

LanguageSelect.propTypes = {
    languageSelected: PropTypes.string.isRequired,
    alertMessage: PropTypes.string,
};

// export default LanguageSelect;